import { Typography, Tag } from "@flash-tecnologia/hros-web-ui-v2";
import * as SC from "./overview.styles";
import { useEffect } from "react";
import { setPageTracking } from "@/utils";
import { TrackingPages } from "../../types";
import { Box } from "@/components/core-components";
import SetupList from "@/components/business-components/organisms/SetupList";
import { RouterOutput } from "@/api/client";

interface OverviewProps {
  setup: RouterOutput["getSetup"];
}

export const Overview: React.FC<OverviewProps> = ({ setup }) => {
  useEffect(() => {
    setPageTracking(TrackingPages.SETUP_OVERVIEW_WORKFLOW_PAGE);
  }, []);

  return (
    <SC.ResponsiveContainer flexDirection="column" gap="s">
      <Box flexDirection="column">
        <Typography.Headline8 color="neutral.20">
          São poucos passos para usar a Flash!
        </Typography.Headline8>
        <Typography.Body4 color="neutral.40">
          Criamos o guia abaixo para te ajudar a iniciar sua jornada com a
          gente.
        </Typography.Body4>
      </Box>
      <SetupList.Root
        title="Comece preparando a plataforma"
        description="Adicione as informações da empresa e equipe em minutos."
      >
        {setup?.baseSteps.map((step, index) => (
          <SetupList.Item
            key={step.title}
            step={step}
            isLast={index === setup.baseSteps.length - 1}
            actionSlot={
              step.required ? (
                <Tag variant="error" size="extra-small" disabled>
                  Obrigatório
                </Tag>
              ) : (
                <Tag variant="gray" size="extra-small" disabled>
                  Opcional
                </Tag>
              )
            }
          />
        ))}
      </SetupList.Root>
    </SC.ResponsiveContainer>
  );
};
